<template>
  <div class="modal-overlay" v-if="isOpen">
    <div class="modal-item">
      <h3 class="text-center mb30">Konfigurasi</h3>
      <form>
        <div class="form-wrapper">
          <div>
            <label style="font-size: small; color: gray;">Keterangan: 1 Hari = 9 Jam</label>
            <div class="left-form">
              <h6 class="text-center mb10">Responden</h6>
              <div class="form-row">
                <label for="SIPM" class="text-bold">L5:</label>

                <input type="number" id="startL5Responden" v-model="startL5Responden" min="0" max="100"
                  class="input-conf" />
                <label class="text-center text-bold">%</label>
                <label class="text-center text-bold">s/d</label>

                <input type="number" id="endL5Responden" v-model="endL5Responden" min="0" max="100"
                  class="input-conf" />
                <label class="text-center text-bold">%</label>
              </div>
              <div class="form-row">
                <label for="SIPM" class="text-bold">L4:</label>
                <input type="number" id="startL4Responden" v-model="startL4Responden" min="0" max="100"
                  class="input-conf" />
                <label class="text-center text-bold">%</label>
                <label class="text-center text-bold">s/d</label>

                <input type="number" id="endL4Responden" v-model="endL4Responden" min="0" max="100"
                  class="input-conf" />
                <label class="text-center text-bold">%</label>
              </div>
              <div class="form-row">
                <label for="SIPM" class="text-bold">L3:</label>

                <input type="number" id="startL3Responden" v-model="startL3Responden" min="0" max="100"
                  class="input-conf" />
                <label class="text-center text-bold">%</label>
                <label class="text-center text-bold">s/d</label>

                <input type="number" id="endL3Responden" v-model="endL3Responden" min="0" max="100"
                  class="input-conf" />
                <label class="text-center text-bold">%</label>
              </div>
              <div class="form-row">
                <label for="SIPM" class="text-bold">L2:</label>

                <input type="number" id="startL2Responden" v-model="startL2Responden" min="0" max="100"
                  class="input-conf" />
                <label class="text-center text-bold">%</label>
                <label class="text-center text-bold">s/d</label>

                <input type="number" id="endL2Responden" v-model="endL2Responden" min="0" max="100"
                  class="input-conf" />
                <label class="text-center text-bold">%</label>
              </div>
              <div class="form-row">
                <label for="SIPM" class="text-bold">L1:</label>
                <input type="number" id="startL1Responden" v-model="startL1Responden" min="0" max="100"
                  class="input-conf" />
                <label class="text-center text-bold">%</label>
                <label class="text-center text-bold">s/d</label>
                <input type="number" id="endL1Responden" v-model="endL1Responden" min="0" max="100"
                  class="input-conf" />
                <label class="text-center text-bold">%</label>
              </div>
            </div>
          </div>

          <div>
            <label style="font-size: small; color: gray;">Keterangan: Total Nilai Puas dan Sangat Puas</label>
            <div class="right-form">
              <h6 class="text-center mb10">Nilai</h6>
              <div class="form-row">
                <label for="SIPM" class="text-bold">L5:</label>

                <input type="number" id="startSIPMhour" v-model="startL5Nilai" min="0" max="100" class="input-conf" />
                <label class="text-center text-bold">%</label>
                <label class="text-center text-bold">s/d</label>
                <input type="number" id="endSIPMhour" v-model="endL5Nilai" min="0" max="100" class="input-conf" />
                <label class="text-center text-bold">%</label>
              </div>
              <div class="form-row">
                <label for="SIPM" class="text-bold">L4:</label>
                <input type="number" id="startSIPMhour" v-model="startL4Nilai" min="0" max="100" class="input-conf" />
                <label class="text-center text-bold">%</label>
                <label class="text-center text-bold">s/d</label>
                <input type="number" id="endSIPMhour" v-model="endL4Nilai" min="0" max="100" class="input-conf" />
                <label class="text-center text-bold">%</label>
              </div>
              <div class="form-row">
                <label for="SIPM" class="text-bold">L3:</label>
                <input type="number" id="startSIPMhour" v-model="startL3Nilai" min="0" max="100" class="input-conf" />
                <label class="text-center text-bold">%</label>
                <label class="text-center text-bold">s/d</label>
                <input type="number" id="endSIPMhour" v-model="endL3Nilai" min="0" max="100" class="input-conf" />
                <label class="text-center text-bold">%</label>
              </div>
              <div class="form-row">
                <label for="SIPM" class="text-bold">L2:</label>
                <input type="number" id="startSIPMhour" v-model="startL2Nilai" min="0" max="100" class="input-conf" />
                <label class="text-center text-bold">%</label>
                <label class="text-center text-bold">s/d</label>
                <input type="number" id="endSIPMhour" v-model="endL2Nilai" min="0" max="100" class="input-conf" />
                <label class="text-center text-bold">%</label>
              </div>
              <div class="form-row">
                <label for="SIPM" class="text-bold">L1:</label>

                <input type="number" id="startSIPMhour" v-model="startL1Nilai" min="0" max="100" class="input-conf" />
                <label class="text-center text-bold">%</label>
                <label class="text-center text-bold">s/d</label>
                <input type="number" id="endSIPMhour" v-model="endL1Nilai" min="0" max="100" class="input-conf" />
                <label class="text-center text-bold">%</label>
              </div>
            </div>
          </div>
        </div>

        <div style="margin: 0 auto;">
          <button @click="closeModal" style="padding: .2rem 1rem;">OK</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { api } from '@/services/config'
export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      startL5Responden: 0,
      endL5Responden: 0,
      startL4Responden: 0,
      endL4Responden: 0,
      startL3Responden: 0,
      endL3Responden: 0,
      startL2Responden: 0,
      endL2Responden: 0,
      startL1Responden: 0,
      endL1Responden: 0,

      startL5Nilai: 0,
      endL5Nilai: 0,
      startL4Nilai: 0,
      endL4Nilai: 0,
      startL3Nilai: 0,
      endL3Nilai: 0,
      startL2Nilai: 0,
      endL2Nilai: 0,
      startL1Nilai: 0,
      endL1Nilai: 0,
    }
  },
  created() {
    this.setConfig()
  },
  methods: {
    async setConfig() {

      try {
        const { data } = await axios({
          method: 'get',
          url: `${api}/api/v1/m-kpi-config?type=6`,
        })

        if (data && data.status == 'success') {
          const getConfig = data.data
          this.startL5Responden = Number(getConfig.filter(i => i.subname == 'L5')[0].firstValue)
          this.endL5Responden = Number(getConfig.filter(i => i.subname == 'L5')[0].secondValue)
          this.startL5Nilai = Number(getConfig.filter(i => i.subname == 'L5')[0].thirdValue)
          this.endL5Nilai = Number(getConfig.filter(i => i.subname == 'L5')[0].fourthValue)

          this.startL4Responden = Number(getConfig.filter(i => i.subname == 'L4')[0].firstValue)
          this.endL4Responden = Number(getConfig.filter(i => i.subname == 'L4')[0].secondValue)
          this.startL4Nilai = Number(getConfig.filter(i => i.subname == 'L4')[0].thirdValue)
          this.endL4Nilai = Number(getConfig.filter(i => i.subname == 'L4')[0].fourthValue)

          this.startL3Responden = Number(getConfig.filter(i => i.subname == 'L3')[0].firstValue)
          this.endL3Responden = Number(getConfig.filter(i => i.subname == 'L3')[0].secondValue)
          this.startL3Nilai = Number(getConfig.filter(i => i.subname == 'L3')[0].thirdValue)
          this.endL3Nilai = Number(getConfig.filter(i => i.subname == 'L3')[0].fourthValue)

          this.startL2Responden = Number(getConfig.filter(i => i.subname == 'L2')[0].firstValue)
          this.endL2Responden = Number(getConfig.filter(i => i.subname == 'L2')[0].secondValue)
          this.startL2Nilai = Number(getConfig.filter(i => i.subname == 'L2')[0].thirdValue)
          this.endL2Nilai = Number(getConfig.filter(i => i.subname == 'L2')[0].fourthValue)

          this.startL1Responden = Number(getConfig.filter(i => i.subname == 'L1')[0].firstValue)
          this.endL1Responden = Number(getConfig.filter(i => i.subname == 'L1')[0].secondValue)
          this.startL1Nilai = Number(getConfig.filter(i => i.subname == 'L1')[0].thirdValue)
          this.endL1Nilai = Number(getConfig.filter(i => i.subname == 'L1')[0].fourthValue)

          this.$store.commit('kpiStore/UPDATE_DATA', {
            name: `for_csi_value`,
            value: {
              l5_id: Number(getConfig.filter(i => i.subname == 'L5')[0].id),
              startL5Responden: this.startL5Responden,
              endL5Responden: this.endL5Responden,
              startL5Nilai: this.startL5Nilai,
              endL5Nilai: this.endL5Nilai,

              l4_id: Number(getConfig.filter(i => i.subname == 'L4')[0].id),
              startL4Responden: this.startL4Responden,
              endL4Responden: this.endL4Responden,
              startL4Nilai: this.startL4Nilai,
              endL4Nilai: this.endL4Nilai,

              l3_id: Number(getConfig.filter(i => i.subname == 'L3')[0].id),
              startL3Responden: this.startL3Responden,
              endL3Responden: this.endL3Responden,
              startL3Nilai: this.startL3Nilai,
              endL3Nilai: this.endL3Nilai,

              l2_id: Number(getConfig.filter(i => i.subname == 'L2')[0].id),
              startL2Responden: this.startL2Responden,
              endL2Responden: this.endL2Responden,
              startL2Nilai: this.startL2Nilai,
              endL2Nilai: this.endL2Nilai,

              l1_id: Number(getConfig.filter(i => i.subname == 'L1')[0].id),
              startL1Responden: this.startL1Responden,
              endL1Responden: this.endL1Responden,
              startL1Nilai: this.startL1Nilai,
              endL1Nilai: this.endL1Nilai,

            },
          })
        }


      } catch (error) {
        console.error(error)
      }
    },
    async closeModal() {
      try {
        const setConfig = {
          ...this.$store.state.kpiStore.for_csi_value,
          startL5Responden: this.startL5Responden,
          endL5Responden: this.endL5Responden,
          startL4Responden: this.startL4Responden,
          endL4Responden: this.endL4Responden,
          startL3Responden: this.startL3Responden,
          endL3Responden: this.endL3Responden,
          startL2Responden: this.startL2Responden,
          endL2Responden: this.endL2Responden,
          startL1Responden: this.startL1Responden,
          endL1Responden: this.endL1Responden,
          startL5Nilai: this.startL5Nilai,
          endL5Nilai: this.endL5Nilai,
          startL4Nilai: this.startL4Nilai,
          endL4Nilai: this.endL4Nilai,
          startL3Nilai: this.startL3Nilai,
          endL3Nilai: this.endL3Nilai,
          startL2Nilai: this.startL2Nilai,
          endL2Nilai: this.endL2Nilai,
          startL1Nilai: this.startL1Nilai,
          endL1Nilai: this.endL1Nilai,
        }

        if (
          setConfig.startL5Responden +
          setConfig.endL5Responden +
          setConfig.startL4Responden +
          setConfig.endL4Responden +
          setConfig.startL3Responden +
          setConfig.endL3Responden +
          setConfig.startL2Responden +
          setConfig.endL2Responden +
          setConfig.startL1Responden +
          setConfig.endL1Responden +
          setConfig.startL5Nilai +
          setConfig.endL5Nilai +
          setConfig.startL4Nilai +
          setConfig.endL4Nilai +
          setConfig.startL3Nilai +
          setConfig.endL3Nilai +
          setConfig.startL2Nilai +
          setConfig.endL2Nilai +
          setConfig.startL1Nilai +
          setConfig.endL1Nilai >
          0
        ) {
          this.$store.commit('kpiStore/UPDATE_DATA', {
            name: `sla_loading`,
            value: true,
          })

          await axios({
            method: 'POST',
            url: `${api}/api/v1/m-kpi-config`,
            data: [
              {
                id: setConfig.l5_id,
                firstValue: setConfig.startL5Responden,
                secondValue: setConfig.endL5Responden,
                thirdValue: setConfig.startL5Nilai,
                fourthValue: setConfig.endL5Nilai,
              },
              {
                id: setConfig.l4_id,
                firstValue: setConfig.startL4Responden,
                secondValue: setConfig.endL4Responden,
                thirdValue: setConfig.startL4Nilai,
                fourthValue: setConfig.endL4Nilai,
              },
              {
                id: setConfig.l3_id,
                firstValue: setConfig.startL3Responden,
                secondValue: setConfig.endL3Responden,
                thirdValue: setConfig.startL3Nilai,
                fourthValue: setConfig.endL3Nilai,
              },
              {
                id: setConfig.l2_id,
                firstValue: setConfig.startL2Responden,
                secondValue: setConfig.endL2Responden,
                thirdValue: setConfig.startL2Nilai,
                fourthValue: setConfig.endL2Nilai,
              },
              {
                id: setConfig.l1_id,
                firstValue: setConfig.startL1Responden,
                secondValue: setConfig.endL1Responden,
                thirdValue: setConfig.startL1Nilai,
                fourthValue: setConfig.endL1Nilai,
              },
            ],
          })

          this.$store.commit('kpiStore/UPDATE_DATA', {
            name: `for_csi_value`,
            value: setConfig,
          })

          this.$store.commit('kpiStore/UPDATE_DATA', {
            name: `sla_loading`,
            value: false,
          })
        }
        this.$emit('close')
      } catch (error) {
        console.error(error)
        this.$store.commit('kpiStore/UPDATE_DATA', {
          name: `sla_loading`,
          value: false,
        })
      }


    },
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-item {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  width: 60vw;
  height: 80vh;
}

form {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  height: 60vh;
  width: 100%;
  margin: 0 auto;
  overflow-y: auto;
}

.form-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: row;
  justify-content: space-evenly;
}

.left-form,
.right-form {
  padding: 0.5rem 2rem;
  display: flex;
  flex-direction: column;
  box-shadow: 0 3px 5px 2px gray;
  border-radius: 15px;
  gap: 0.5rem;
  width: 325px;
}

.form-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 10px;
}

.modal-item input {
  padding: 0.2rem;
  height: 30px;
  width: 60px;
}

.modal-item button {
  padding: 0.1rem 0.5rem;
  background-color: white;
  color: red;
  border: solid 1px red;
  border-radius: 5px;
  cursor: pointer;
  margin: 10px auto;
}

.modal-item button:hover {
  background-color: red;
  color: white;
  border: solid 1px white;
}
</style>
